<script setup>

import {t} from "i18next";
import {useAuth} from "@/stores/auth.js";
import {computed, ref} from "vue";
import HeaderAuthComponent from "@/components/auth/HeaderAuthComponent.vue";
import {useAppKit, useAppKitAccount, useAppKitEvents} from '@reown/appkit/vue';
import {storeToRefs} from "pinia";
import ConfirmEmailModal from "@/components/auth/ConfirmEmailModal.vue";
import PurchaseTokenModal from "@/components/modals/PurchaseTokenModal.vue";

const accountData = useAppKitAccount()
const {open: openWallet} = useAppKit();
const walletConnected = ref(false);

const auth = useAuth();
const {user} = storeToRefs(auth);

const confirmEmailModal = ref(null);
const purchaseTokenModal = ref(null);


const mobileMenu = ref(null);
const navBurger = ref(null);

const fullName = computed(() => {
  if (!user.value || !user.value.contact) {
    return t('customer.sidebar.nameSurname', 'Name Surname');
  }
  return user.value.contact.first_name + " " + user.value.contact.last_name
});

const handleOpen = () => {
  try{
    open();
  } catch(_e){
    open();
  }
}

const openMenu = () => {
  // const mobileMenuBurger = document.getElementById("nav-burger");
  // const mobileMenu = document.getElementById("mobile-menu");

  navBurger.value.classList.toggle("open");
  mobileMenu.value.classList.toggle("active");
}
const logout = async () => {
  await auth.logout();
}

const onBuyToken = () => {
  if (!auth.user) {
    registerStep();
    return;
  }

  if (auth.user && !auth.user.email_verified_at) {
    emailVerificationStep();
    return;
  }

  if (!accountData.value.status || !accountData.value.isConnected) {
    walletConnectStep();
    return;
  }

  purchaseTokenStep();

}

const loginStep = () => {
  auth.showAuthModal();
  // TODO handle the modal and eventbus logic. perhaps do it differently
  // EventBus.$once('login', () => {
  //   purchaseNFTModal.value.showModal(opportunity.value.uuid, nft_count.value);
  // });
  //
  // EventBus.$once('register', () => {
  //   purchaseNFTModal.value.showModal(opportunity.value.uuid, nft_count.value);
  // });
  const unsubscribe = auth.$onAction(
      ({
         name, // name of the action
         after, // hook after the action returns or resolves
         onError, // hook if the action throws or rejects
       }) => {
        if (name !== 'setUser') {
          return;
        }
        onError((e) => {
          unsubscribe();
        });
        after(() => {
          if (auth.user && !auth.user.email_verified_at) {
            emailVerificationStep();
            unsubscribe();
            return;
          }
          if (!accountData.value.status || !accountData.value.isConnected) {
            walletConnectStep();
            unsubscribe();
            return;
          }
          purchaseTokenStep();
          unsubscribe();
        });
      });
}

const registerStep = () => {
  auth.showRegisterModal();
  // TODO handle the modal and eventbus logic. perhaps do it differently
  // EventBus.$once('login', () => {
  //   purchaseNFTModal.value.showModal(opportunity.value.uuid, nft_count.value);
  // });
  //
  // EventBus.$once('register', () => {
  //   purchaseNFTModal.value.showModal(opportunity.value.uuid, nft_count.value);
  // });
  const unsubscribe = auth.$onAction(
      ({
         name, // name of the action
         after, // hook after the action returns or resolves
         onError, // hook if the action throws or rejects
       }) => {
        if (name !== 'setUser') {
          return;
        }
        onError((e) => {
          unsubscribe();
        });
        after(() => {
          if (auth.user && !auth.user.email_verified_at) {
            emailVerificationStep();
            unsubscribe();
            return;
          }
          if (!accountData.value.status || !accountData.value.isConnected) {
            walletConnectStep();
            unsubscribe();
            return;
          }
          purchaseTokenStep();
          unsubscribe();
        });
      });
}

const emailVerificationStep = () => {
  confirmEmailModal.value.showModal();
  const unsubscribe = auth.$onAction(
      ({
         name, // name of the action
         after, // hook after the action returns or resolves
         onError, // hook if the action throws or rejects
       }) => {
        if (name !== 'loadUser') {
          return;
        }
        onError((e) => {
          unsubscribe();
        });
        after(() => {
          if (auth.user && !auth.user.email_verified_at) {
            emailVerificationStep();
            unsubscribe();
            return;
          }
          if (!accountData.value.status || !accountData.value.isConnected) {
            walletConnectStep();
            unsubscribe();
            return;
          }
          purchaseTokenStep();
          unsubscribe();
        });
      });

}

const walletConnectStep = () => {
  openWallet();
  window.appkit.subscribeAccount((state) => {
    if (walletConnected.value) {
      return;
    }

    if (state.isConnected) {
      walletConnected.value = true;
      purchaseTokenStep();
    }
  });
}

const purchaseTokenStep = () => {
  purchaseTokenModal.value.showModal();
}

// const onBuyTokenContainer = (event) => {
//   console.log(event.target)
//   event.target.firstChild.click();
// }

</script>

<template>
  <header class="sticky-top text-uppercase">
    <div class="container-fluid container-xl">
<!--      <nav class="navbar navbar-light">-->
<!--        <a class="navbar-brand pointer" href="/">-->
<!--          <img alt="LEND7" src="@/assets/logo.svg" width="125" height="125" />-->
<!--        </a>-->

<!--        <div class="navbar-nav mx-auto">-->
<!--          <a href="/en#opportunities" class="nav-item nav-link router-link-active px-3">Opportunities</a>-->
<!--        </div>-->
<!--      </nav>-->

      <div
          class="navbar-nav flex-row justify-content-between align-items-center"
      >
        <div class="navbar-nav mb-3">
          <a class="nav-item nav-link pointer" href="/">
            <img
                class="img-fluid header-logo"
                src="@/assets/header_logo.png"
                alt="Lend7"
            />
          </a>
        </div>
        <div class="d-none d-lg-flex align-items-center">
          <router-link
              class="px-3"
              :to="{ name: 'home' }"
          >{{ t("header.navigation.home") }}
          </router-link>
          <router-link
              class="px-3"
              :to="{ name: 'opportunities' }"
          >{{ t("header.navigation.opportunities") }}
          </router-link>
          <a href="/docs/NEXT_GENERATION_LITHUANIA.pdf"
             class="px-3"
             target="_blank">
            {{ t("header.navigation.eu-investment") }}
          </a>
          <router-link
              class="px-3"
              :to="{ name: 'about-us' }"
          >
            {{ t("header.navigation.about") }}
          </router-link>
          <router-link
              class="px-3"
              :to="{ name: 'home', hash: '#newsletter' }"
          >{{ t("header.navigation.contacts") }}
          </router-link>

<!--          <div class="d-flex align-items-center justify-content-center token-btn me-3">-->
            <a v-if="!auth.user" class="token-btn" @click="onBuyToken">
              {{ t("header.navigation.register") }}
            </a>
<!--          </div>-->

<!--          <button class="btn token-btn" @click="handleOpen">Buy token</button>-->

          <HeaderAuthComponent />

<!--          <button class="btn wallet-btn ms-3" @click="handleOpen">Connect</button>-->
        </div>
        <div id="nav-burger" ref="navBurger" class="d-lg-none me-1" @click="openMenu()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </header>

  <div id="mobile-menu" ref="mobileMenu"
       class="w-100 pb-4 align-items-center justify-content-start d-lg-none text-dark">
    <div class="w-100 py-5">
      <div v-if="auth.user" class="admin-menu py-3">
        <div
            class="container menu-header d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center justify-content-start">
            <a
                data-bs-toggle="collapse"
                href="#menu_collapse"
                role="button"
                aria-expanded="false"
                aria-controls="menu_collapse"
            >
              <img
                  class="person me-3"
                  src="@/assets/images/person.png"
                  alt="Person logo"
              />
            </a>
            <div class="text-white text-start">
              <span>MY ACCOUNT</span>
              <h4>
                {{ fullName }}
              </h4>
            </div>
          </div>
          <img
              class="logout"
              @click="logout"
              src="@/assets/icons/logout.svg"
              alt="Logout"
          />
        </div>

        <div id="menu_collapse" class="text-white auth-nav">
          <div @click="openMenu()" class="d-flex flex-column">
              <router-link
                  class="text-dark text-decoration-none d-block p-3"
                  :to="{ name: 'customer.overview' }"
              >
                {{ t("customer.sidebar.overview") }}
              </router-link>
              <router-link
                  class="text-dark text-decoration-none d-block p-3"
                  :to="{ name: 'customer.investments' }"
              >
                {{ t("customer.sidebar.investments") }}
              </router-link>
              <router-link
                  class="text-dark text-decoration-none d-block p-3"
                  :to="{ name: 'customer.manage-account' }"
              >
                {{ t("customer.sidebar.manage-account") }}
              </router-link>
          </div>
        </div>
      </div>

      <div class="text-center py-2"
           @click="openMenu()">
        <router-link
            class="px-3"
            :to="{ name: 'home' }"
        >
          {{ t("header.navigation.home") }}
        </router-link>
      </div>
      <div class="text-center py-2"
           @click="openMenu()">
        <router-link
            class="px-3"
            :to="{ name: 'opportunities' }"
        >
          {{ t("header.navigation.opportunities") }}
        </router-link>
      </div>

      <div class="text-center py-2" @click="openMenu()">
        <a href="/docs/NEXT_GENERATION_LITHUANIA.pdf" target="_blank">
          {{ t("header.navigation.eu-investment") }}
        </a>
      </div>
      <div @click="openMenu()" class="text-center py-2">
        <router-link
            class="px-3"
            :to="{ name: 'about-us' }"
        >
          {{ t("header.navigation.about") }}
        </router-link>
      </div>
      <div @click="openMenu()" class="text-center py-2">
        <router-link
            class="px-3"
            :to="{ name: 'home', hash: '#newsletter' }"
        >
          {{ t("header.navigation.contacts") }}
        </router-link>
      </div>
      <div v-if="!auth.user" class="text-center">
<!--        <div class="d-flex align-items-center justify-content-center token-btn">-->
          <a class="token-btn" @click="onBuyToken">
            {{ t("header.navigation.register") }}
          </a>
<!--        </div>-->
      </div>
      <div class="text-center">
        <HeaderAuthComponent />
      </div>
    </div>
  </div>

  <ConfirmEmailModal ref="confirmEmailModal"/>
  <PurchaseTokenModal ref="purchaseTokenModal"/>
</template>